import React, { useState } from 'react'
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FohDeployment from './FohDeployment';
import BohDeployment from './BohDeployment';
import { formatDate } from '../requests/utilities/helpers';
import { formatDateReadable } from '../requests/utilities/helpers';
import { getRightworkAPI } from '../requests/utilities/requests';
import { API_get_list_users } from '../../../constants';
import LoadSpinner from '../../../utilities/LoadSpinner';
import SubTabs from '../home/top_bar_components/SubTabs';
import './DeploymentDisplay2.css';

function DeploymentDisplay2(props) {

  const [employees, setEmployees] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [hasInitialLoad, setHasInitialLoad] = React.useState(false)

  const fetchEmployees = async (showLoading) => {
    setIsLoading(showLoading);
    let api_params = { store_id: props.homeStore };
    let api = API_get_list_users;
    try {
      const res = await getRightworkAPI(api, api_params);
      // console.log(res);
      if (res.status === 200) {
        const data = res.data?.redux?.payload?.employees
        setEmployees(data);
        setHasInitialLoad(true);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      throw Error(error);
    }
  };

  React.useEffect(() => {
    if (props.homeStore) {
      fetchEmployees(true);
    }
  }, [props.homeStore]);


  const fohEmployees = employees?.filter(x => x.primary_role_type_name === "FOH")
  const bohEmployees = employees?.filter(x => x.primary_role_type_name === "BOH")

  const [activeTab, setActiveTab] = useState('foh')

  const tabs = [
    {
      id: 'foh',
      label: 'Front of House',
      icon: RestaurantIcon,
      count: fohEmployees?.length || 0
    },
    {
      id: 'boh',
      label: 'Back of House',
      icon: LunchDiningIcon,
      count: bohEmployees?.length || 0
    }
  ]



  return (
    <>
      {!isLoading ?
        <div className="min-h-screen bg-gray-50">
          {/* Header + sub-tabs (same shape as Tickets / Contests) */}
          <div className="bg-white border-b border-slate-200 px-8 py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <RestaurantIcon className="text-violet-700" />
                <h1 className="text-2xl font-semibold text-slate-900">
                  Deployment
                </h1>
              </div>
              <div className="flex items-center gap-2 text-slate-500">
                <CalendarMonthIcon style={{ fontSize: "16px" }} />
                <span className="text-sm">{formatDateReadable(formatDate(new Date()))}</span>
              </div>
            </div>
            <SubTabs
              className="mt-4"
              tabs={tabs.map((tab) => ({
                key: tab.id,
                label: `${tab.label} (${tab.count})`,
                icon: tab.icon,
              }))}
              activeTab={activeTab}
              onChange={setActiveTab}
            />
          </div>

          {/* Tab Content - Only render after initial employee data is loaded */}
          {hasInitialLoad && (
            <div className="transition-all duration-300 ease-in-out">
              {activeTab === 'foh' && (
                <div className="animate-fadeIn">
                  <FohDeployment
                    employees={fohEmployees}
                  />
                </div>
              )}

              {activeTab === 'boh' && (
                <div className="animate-fadeIn">
                  <BohDeployment
                    employees={bohEmployees}
                  />
                </div>
              )}
            </div>
          )}

          {/* Show loading state if data hasn't loaded yet but not in main loading */}
          {!hasInitialLoad && !isLoading && (
            <div className="flex items-center justify-center h-64">
              <div className="text-gray-500">Loading deployment data...</div>
            </div>
          )}
        </div> :
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadSpinner />
        </div>
      }
    </>
  )
}

export default DeploymentDisplay2
